import { Header, ProgressBar } from '@components/Generic'
import { observer } from 'mobx-react'
import { useContext, useEffect, useState } from 'react'
import { useInterval } from 'usehooks-ts'
import { StoreContext } from '@store/Root.store'
import { axiosInstance } from '@methods/axiosConfig'
import { devLog } from '@methods/devLog'
import { forceRedirect } from '@methods/forceRedirect'
import { API_URL, ONBOARDING_SERVICE_PATH } from '@constants/apiUrl'

export const ProgressPage = observer(() => {
  const store = useContext(StoreContext)
  const { progressPage: trans } = store.TranslationsState.translations
  const [verified, setVerified] = useState(false)

  const handlePooling = async () => {
    try {
      const res = await axiosInstance.get(`${API_URL}/${ONBOARDING_SERVICE_PATH}/waiting`, {
        withCredentials: true,
      })

      if (res.data) {
        const { isCompleted } = res.data
        if (isCompleted === true) {
          setVerified(true)
        }
      }
    } catch (e) {
      devLog(e)
    }
  }

  useInterval(
    () => {
      !verified && handlePooling()
    },
    !verified ? 3000 : null
  )

  useEffect(() => {
    if (verified) {
      forceRedirect(`${API_URL}/${ONBOARDING_SERVICE_PATH}/redirect-from-waiting`)
    }
  }, [verified])

  useEffect(() => {
    localStorage.setItem('show-waiting-screen', 'false')
  }, [])

  return (
    <div className="page-container mobile-m-10">
      <div className="layout__margined m-0-0-15">
        <Header>{trans.heading}</Header>
      </div>
      <div className="generic__subheading">{trans.wait}</div>
      <ProgressBar time={180} secondChance={true} longerWait={trans.waitMore} />
    </div>
  )
})
